import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {startLevel} from "../../../game/actions";
import {IApplicationState} from "../../../index";

export default function startLevelHandler(action: ActionType<typeof startLevel>, state: IApplicationState): IAnalyticsAction | undefined {
    if (state.game.levelMapProgress[action.payload.level] && state.game.levelMapProgress[action.payload.level].answeredTileCount > 0)
        return;

    return {
        category: "level",
        object: "level",
        name: "start",
        levelId: action.payload.level,
    };
}